import script from "./mainFoots.vue?vue&type=script&setup=true&lang=js"
export * from "./mainFoots.vue?vue&type=script&setup=true&lang=js"

import "./mainFoots.vue?vue&type=style&index=0&id=ee9e96ec&scoped=true&lang=css"

import exportComponent from "E:\\茂侨项目文件夹\\monitoring-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ee9e96ec"]])

export default __exports__